<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select class="filter-item" v-model="filters.type" placeholder="充值类型">
                <el-option value="" label="全部"></el-option>
                <el-option :value="0" label="充值"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.status" placeholder="审核状态">
                <el-option value="" label="全部"></el-option>
                <el-option :value="0" label="待审核"></el-option>
                <el-option :value="1" label="审核成功"></el-option>
                <el-option :value="2" label="审核失败"></el-option>
            </el-select>
            <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="选择开始日期" value-format="YYYY-MM-DD"></el-date-picker>
            <span class="filter-item">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="选择结束日期" value-format="YYYY-MM-DD"></el-date-picker>
            <el-select v-if="userType==1" class="filter-item" filterable v-model="filters.channel_no" placeholder="请选择渠道">
                <el-option v-for="item in channelList" :key="item.id" :label="item.channel_name" :value="item.channel_no"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <!-- <el-button class="filter-btn" type="primary" @click="output()">批量导出</el-button> -->
            <el-button v-if="userType==1" class="filter-btn" type="primary" @click="batchDelivery()">批量充值</el-button>

        </div>
        <el-table :data="tableData" border style="width:100%">
            <el-table-column prop="id" label="充值ID"></el-table-column>
            <el-table-column prop="admin_name" label="上传人"></el-table-column>
            <el-table-column prop="check_name" label="审核人"></el-table-column>
            <el-table-column prop="price" label="充值总金额"></el-table-column>
            <el-table-column prop="number" label="充值人数"></el-table-column>
            <el-table-column prop="channel_no" label="渠道"></el-table-column>
            <el-table-column prop="created_at" label="充值时间"></el-table-column>
            <el-table-column prop="updated_at" label="修改时间"></el-table-column>
            <el-table-column label="审核状态">
                <template #default="scope">
                    {{ RechargeCheckStatus[scope.row.status] }}
                </template>
            </el-table-column>
            <el-table-column label="充值类型">
                <template #default="scope">
                    {{ scope.row.type == 0 ? '金额充值' : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作" >
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="rechargeInfo(scope.$index, scope.row)">充值详情</el-button>
                        <el-button v-if="scope.row.status != 1 && userType==1" type="primary" size="small" class="mt10" @click="delRechargeInfo(scope.$index, scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <el-dialog title="批量充值" v-model="dialogBatchDelivery" :before-close="beforeClose">
            <el-form class="form" label-width="150px">
                <el-form-item label="充值类型：">
                    <el-select class="filter-item" v-model="recharge_type" placeholder="充值类型">
                        <el-option :value="0+''" label="充值"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道：">
                    <el-select class="filter-item" filterable v-model="channel_no" placeholder="请选择渠道">
                        <el-option v-for="item in channelList" :key="item.id" :label="item.channel_no" :value="item.channel_no"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文件上传：" prop="image">
                    <el-upload
                        class="avatar-uploader"
                        ref="batchDeliveryForm"
                        :action="`/api/admin/recharge/batchRecharge?channel_no=${channel_no}&recharge_type=${recharge_type}`"
                        :show-file-list="true"
                        :on-success="handleAvatarSuccess"
                        :auto-upload="false"
                        :limit="1"
                        :on-exceed="handleExceed"
                        accept=".xlsx,.xls"
                    >
                        <i class="el-icon-plus avatar-uploader-icon" style="font-style:normal;">选取文件</i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link v-if="recharge_type == 0"  :href="`${Keys.baseUrl}/admin/recharge/downLoadExcel?type=${recharge_type}`" type="primary">下载充值模板</el-link>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="success" @click="submitUpload()" :disabled="uploadDisabled">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="filters.page"
            :page-size="filters.limit"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { joinParams } from '@/utils/index'
import { RechargeCheckStatus } from '@/enums/coupon'
import Keys from '@/constant/key'
import { ElMessageBox } from 'element-plus'

export default defineComponent({
name: 'RechargeList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    const userType = store.state.user.userInfo.user_type

    const state = reactive({
        filters: {
            type:       null,   // 充值类型
            channel_no: '',     // 渠道号
            status:     null,   // 审核状态
            start_date: '',     // 开始日期
            end_date:   '',     // 结束日期
            limit:      10,     // 每页条数
            page:       1,      // 当前页码
        },
        dialogBatchDelivery: false, // 批量充值弹框
        tableData:      [],     // 表格数据
        channelList:    [],     // 渠道列表
        total:          0,      // 表格总条数
        channel_no:     '',     // 渠道号
        recharge_type:  '0',    // 充值类型
        file:           {},     // 上传文件信息
        uploadDisabled: false, // 上传按钮禁用

        // 获取表格数据
        getList(){
            proxy.$http.get(`/admin/recharge/getRechargeList?${joinParams(state.filters)}`).then(res => {
                if(res.code == 0){
                    state.tableData = res.data;
                    state.total = res.count;
                }else{
                    state.tableData = [];
                }
                
            })
        },
        // 获取渠道列表
        getChannelList:()=>{
            proxy.$http.get(`/admin/user/getChannelList`).then((res) => {
                if(res.code == 0){
                    state.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 搜索
        search(){
            state.filters.page = 1
            state.getList()
        },
        batchDelivery(){
            state.dialogBatchDelivery = true;
        },
        handleExceed () {
            proxy.$message.warning('只能上传一个文件');
        },
        // 提交上传
        submitUpload: () => {
            if(state.channel_no == '' || state.recharge_type == ''){
                proxy.$message({
                    type: 'error',
                    message: '请选择充值的渠道和充值类型！'
                });
                return false;
            }
            store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
            proxy.$refs.batchDeliveryForm.submit()
            state.uploadDisabled = true
        },
        // 批量发货-上传文件成功
        handleAvatarSuccess: (res,file) => {
            state.uploadDisabled = false;
            store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
            if(res.code == '0'){
                ElMessageBox.alert('操作成功', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    customClass: 'el-message-box--scope',
                    callback: () => {
                        state.beforeClose()
                        state.getList()
                    }
                })
            }else{
                ElMessageBox.alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    customClass: 'el-message-box--scope',
                    callback: () => {
                    }
                })
            }
        },
        beforeClose: () => {
            state.dialogBatchDelivery = false;
            state.file = {};
            state.channel_no = '';
            state.uploadDisabled = false;
            proxy.$refs.batchDeliveryForm.clearFiles();
        },
        rechargeInfo(index,row){
            router.push('/partner/recharge-info?id='+row.id);
        },
        delRechargeInfo(index,row){
            proxy.$confirm(`确定要删除吗？`, '提示', {
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                proxy.$http.get(`/admin/recharge/delRechargeInfo?id=${row.id}`).then((res) => {
                    if(res.code == 0){
                        // state.channelList = res.data;
                        proxy.$message({type:'success',message:res.msg});
                        location.reload();
                    }else{
                        proxy.$message({type:'error',message:res.msg});
                    }
                })
            });
        },
        onPageChange(val) {
            state.filters.page = val
            state.getList()
        },
        onSizeChange  (val) {
            state.filters.limit = val
            state.getList()
        },
    })
    state.getList()
    userType==1 && state.getChannelList()

    return { ...toRefs(state), Keys, store, userType, RechargeCheckStatus }
}
})
</script>

<style lang="stylus">
    // .el-message-box--scope
    //     font-size 16px !important
    //     .el-message-box__title, .el-message-box__content
    //         font-size 16px !important
</style>